import {numerator} from "./Numerator"

export const ingredient = {
    numerator: numerator,
    classCode: {}, // role
    activeMoiety: {},
    asEquivalentSubstance: {},
    ingredientName: {},
}